import React from 'react';

export default props => {
    return (
        <svg width={props.width || '17px'} height={props.height || '16px'} viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="btn-close" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Fag-utlisting-Copy-15" transform="translate(-881.000000, -343.000000)" fill={props.color || '#FFFFFF'}>
                    <g id="Group-2" transform="translate(889.500000, 350.500000) rotate(-315.000000) translate(-889.500000, -350.500000) translate(880.000000, 341.000000)">
                        <rect id="Rectangle-3" transform="translate(9.778175, 9.778175) rotate(-360.000000) translate(-9.778175, -9.778175) " x="0.778174593" y="7.77817459" width="18" height="4"></rect>
                        <rect id="Rectangle-3" transform="translate(9.778175, 9.778175) rotate(-90.000000) translate(-9.778175, -9.778175) " x="0.778174593" y="7.77817459" width="18" height="4"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/CloseIcon.js